import React from "react"
import {getOrgName, Org} from "../../resources/org"
import {Filter} from "../Filter/Filter"
import moment from "moment"
import {AsyncResultRequestState} from "../../types/asyncResult"
import {ErrorDocument, RiskRate} from "../../resources/common"

const noOrgData: Org = {
	id: "-1",
	type: "org",
	attributes: {
		createdAt: new Date(Date.now()),
		name: "N/A",
		defaultCustomerRiskRate: RiskRate.Low,
		orgInterchangeShare: 0,
		enableTwoFactorAuthentication: false,
	},
}

export const OrgFilter = (
	orgs: AsyncResultRequestState<Org[], ErrorDocument>,
	setFilteredOrgs: (orgs: string[]) => void,
	filteredOrgs: string[],
	reset: (limit: number) => void,
	limit: number
) => {
	const readyToLaunchOrgs = orgs.match(
		() => [],
		(orgs) => orgs.filter((org) => typeof org.relationships?.parentOrg !== "undefined").map((org) => org.id),
		() => []
	)

	return orgs.match(
		() => null,
		(orgs) => (
			<Filter
				title="Orgs"
				isSearchable
				setStatuses={setFilteredOrgs}
				statuses={filteredOrgs}
				onFilterFunc={() => reset(limit)}
				options={
					new Map<string, string>(
						[...orgs, noOrgData]
							.sort((a, b) => moment(b.attributes.createdAt).diff(moment(a.attributes.createdAt)))
							.map((org) => [org.id, getOrgName(org)])
					)
				}
				customSelections={[
					{
						name: "Ready to launch",
						filterFn: ([option, _]) => {
							return readyToLaunchOrgs.includes(option as string)
						},
					},
				]}
			/>
		),
		(_) => null
	)
}
